import _ from "lodash";
import {
  SHOW_SUPPLIED_BY_FOOTER,
  HIDE_SUPPLIED_BY_FOOTER
} from "../actions/types";

const INITIAL_STATE = false

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_SUPPLIED_BY_FOOTER: 
      return true;
    case HIDE_SUPPLIED_BY_FOOTER: 
      return false  
    default:
      return state;
  }
};
